import { Collapse, List, Stack, Box } from "@mui/material";
import React from "react";
import ListItemButton from "../ListItemButton";

interface ICustomCollapseProps {
  label?: string;
  onClick?: () => void;
  isOpen?: boolean;
  children?: React.ReactNode | React.ReactNode[];
  icon?: React.ReactNode;
  isActive?: boolean;
}

const CustomCollapse: React.FC<ICustomCollapseProps> = ({
  onClick,
  label,
  isOpen,
  children,
  icon,
  isActive,
}) => {
  return (
    <>
      <ListItemButton
        onClick={onClick}
        label={label}
        enableRightArrow
        rightArrowRotate={isOpen ? "90deg" : "none"}
        icon={icon}
        isActive={isActive}
      />
      <Collapse 
        in={isOpen} 
        timeout={300}
        unmountOnExit
        sx={{
          marginTop: "4px",
        }}
      >
        <Box
          sx={{
            marginLeft: "20px",
            paddingLeft: "20px",
            borderLeft: "2px solid rgba(255, 255, 255, 0.1)",
            marginTop: "8px",
            marginBottom: "4px",
          }}
        >
          <Stack gap={0.5}>{children}</Stack>
        </Box>
      </Collapse>
    </>
  );
};

export default CustomCollapse;
